import { axios } from "../config";

export function getSuperAdminStatisticsData() {
  return axios.get("api/v1/analytics/dashboard");
}

export function getAdminDashboardData() {
  return axios.get("api/v1/analytics/admin-dashboard");
}

export function getTeacherAttendanceData() {
  return axios.get("api/v1/analytics/teacher-attendance-overview");
}

export function getInstitutionCount() {
  return axios.get("api/v1/institutions/count");
}

export function getTeacherLeaveApprovalData(data) {
  return axios.get("/api/v1/analytics/teacher-leave-overview", {
    params: data,
  });
}

export const getEventsList = (data) => {
  return axios.get("api/v1/institutions/calendar-exceptions", {
    params: data,
  });
};

export const getUnconParentList = (data) => {
  return axios.get("api/v1/analytics/unregistered-parents", {
    params: data,
  });
};

export const getStudentAttenList = () => {
  return axios.get("api/v1/analytics/students-presence-stats");
};
